<template>
    <div>
        <div v-if='current.matches("loading.loading")'>
            <loading-spinner></loading-spinner>
        </div>
        <div class='resourceTiles' v-else>
            <tag-tile v-for='tag in tags' :tag='tag' :key='tag'></tag-tile>
        </div>
    </div>
</template>

<script>
import { createMachine, interpret } from "xstate";
import axios from 'axios'
import LoadingSpinner from '../components/LoadingSpinner'
import TagTile from '../components/TagTile'

const stateMachine = createMachine({
    id: 'resourceSearchState',
    type: 'parallel',
    states: {
        loading: {
            initial: 'loading',
            states: {
                loading: {
                    on: { SWITCH_LOADED: 'loaded' }
                },
                loaded: {
                    on: { SWITCH_LOADING: 'loading' }
                }
            }
        }
    }
});

export default {
    data() {
        return {
            tags: [],
            current: stateMachine.initialState,
            stateService: interpret(stateMachine),
        }
    },
    methods: {
        refresh() {
            this.stateService.send('SWITCH_LOADING');

            axios.get(`${this.$api}/resource/tags`).then(result => {
                this.tags = result.data;
                this.stateService.send('SWITCH_LOADED');
            });
        }
    },
    created() {
        this.stateService
            .onTransition(state => {
                this.current = state;
            })
            .start();

        this.refresh();
    },
    components: {
        'loading-spinner': LoadingSpinner,
        'tag-tile': TagTile
    }
}
</script>